import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { alpha } from '@mui/material/styles';
import { Box, Chip, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import SectionHeading from '../../components/Common/SectionHeading';
import { aboutValues, highlightStats, pageContent, strengthChips } from '../../data/siteData';

function AboutPage() {
  const content = pageContent.about;

  return (
    <Box>
      <PageBanner {...content.banner} />
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={5}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                height: '100%',
                color: '#ffffff',
                background: 'linear-gradient(180deg, rgba(74,14,143,1) 0%, rgba(26,5,51,1) 100%)',
              }}
            >
              <Typography variant="overline" sx={{ color: '#e0c068', letterSpacing: 2 }}>
                Mission
              </Typography>
              <Typography variant="h3" sx={{ color: '#ffffff', mb: 2 }}>
                {content.missionTitle}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.74)', lineHeight: 1.8, mb: 3 }}>
                {content.missionDescription}
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2 }}>
                {highlightStats.map((stat) => (
                  <Paper key={stat.label} elevation={0} sx={{ p: 2, bgcolor: alpha('#ffffff', 0.06), color: '#ffffff' }}>
                    <Typography variant="h4" sx={{ color: '#e0c068' }}>{stat.value}</Typography>
                    <Typography sx={{ color: 'rgba(255,255,255,0.7)' }}>{stat.label}</Typography>
                  </Paper>
                ))}
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={7}>
            <Stack spacing={2.5}>
              {content.story.map((paragraph) => (
                <Typography key={paragraph} sx={{ color: 'text.secondary', lineHeight: 1.85 }}>
                  {paragraph}
                </Typography>
              ))}
              <Stack direction="row" flexWrap="wrap" gap={1.1} sx={{ pt: 1 }}>
                {strengthChips.map((chip) => (
                  <Chip
                    key={chip}
                    icon={<CheckCircleRoundedIcon />}
                    label={chip}
                    sx={{
                      bgcolor: '#fff6de',
                      color: '#4a0e8f',
                      border: '1px solid rgba(201,168,76,0.28)',
                      '& .MuiChip-icon': { color: '#c9a84c' },
                    }}
                  />
                ))}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ bgcolor: '#fffdfa', py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <SectionHeading
            eyebrow={content.valuesSection.eyebrow}
            title={content.valuesSection.title}
            subtitle={content.valuesSection.subtitle}
          />
          <Grid container spacing={3}>
            {aboutValues.map((item) => {
              const Icon = item.icon;
              return (
                <Grid item xs={12} md={4} key={item.title}>
                  <Paper elevation={0} sx={{ p: 3, height: '100%' }}>
                    <Icon sx={{ color: '#c9a84c', fontSize: 34 }} />
                    <Typography variant="h4" sx={{ mt: 2, mb: 1.2 }}>{item.title}</Typography>
                    <Typography sx={{ color: 'text.secondary', lineHeight: 1.75 }}>
                      {item.description}
                    </Typography>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

export default AboutPage;
